var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('Loading',{attrs:{"loaded":_vm.loaded}}),(_vm.productDetailId)?_c('product-detail-modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }